import { FC, SVGProps } from "react";

const ChequeBackground: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg viewBox="0 0 472 259" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g>
        <path
          d="M472 0H0V259H472V0Z"
          fill="url(#paint0_linear_510_335)"
          stroke="url(#paint1_linear_510_335)"
          strokeMiterlimit="10"
        />
        <path
          d="M337 129.5L307.414 159.233V201.267H265.586L236 231L206.414 201.267H164.586V159.233L135 129.5L164.586 99.7673V57.7327H206.414L236 28L265.586 57.7327H307.414V99.7673L337 129.5Z"
          stroke="white"
          strokeMiterlimit="10"
        />
        <path
          d="M315 129.5L291.851 152.796V185.704H259.149L236 209L212.88 185.704H180.149V152.796L157 129.5L180.149 106.234V73.2956H212.88L236 50L259.149 73.2956H291.851V106.234L315 129.5Z"
          stroke="white"
          strokeMiterlimit="10"
        />
        <path
          d="M24.5575 0L18.2418 6.42455L14.6472 10.0573L21.87 17.4909L25.3302 21.0564L32.553 28.4564L36.114 32.1227L28.9248 39.4555L25.431 42.9873L18.2418 50.32L14.6472 53.9527L21.87 61.3527L25.3302 64.9182L32.553 72.3182L36.114 76.0182L28.9248 83.3509L25.431 86.8827L18.2418 94.2155L14.6472 97.8482L21.87 105.248L25.3302 108.814L32.553 116.214L36.114 119.914L28.9248 127.213L25.431 130.778L18.2418 138.077L14.6472 141.744L21.87 149.144L25.3302 152.709L32.553 160.109L36.114 163.775L28.9248 171.108L25.431 174.64L18.2418 181.973L14.6472 185.605L21.87 193.039L25.3302 196.605L32.553 204.005L36.114 207.671L28.9248 215.004L25.431 218.535L18.2418 225.868L14.6472 229.501L21.87 236.901L25.3302 240.5L32.553 247.9L36.114 251.566L28.9248 258.899L28.824 259"
          stroke="#CAA3CE"
          strokeMiterlimit="10"
        />
        <path
          d="M33.2249 0L36.114 2.96L32.6538 6.49182L25.431 13.8245L21.87 17.4909L14.6472 24.79L18.141 28.3555L25.3302 35.7891L28.9248 39.4555L36.114 46.8555L32.6538 50.3873L25.431 57.72L21.87 61.3527L14.6472 68.6855L18.141 72.2509L25.3302 79.6509L28.9248 83.3509L36.114 90.7509L32.6538 94.2827L25.431 101.615L21.87 105.248L14.6472 112.581L18.141 116.146L25.3302 123.546L28.9248 127.213L36.114 134.613L32.6538 138.178L25.431 145.477L21.87 149.144L14.6472 156.476L18.141 160.042L25.3302 167.442L28.9248 171.108L36.114 178.508L32.6538 182.04L25.431 189.373L21.87 193.039L14.6472 200.372L18.141 203.937L25.3302 211.337L28.9248 215.004L36.114 222.404L32.6538 225.935L25.431 233.268L21.87 236.901L14.6472 244.234L18.141 247.799L25.3302 255.233L28.9248 258.899L29.0256 259"
          stroke="#CAA3CE"
          strokeMiterlimit="10"
        />
        <path
          d="M17.3684 0L14.6472 2.75818L18.2418 6.42455L25.431 13.8245L28.9248 17.39L36.114 24.79L32.553 28.4564L25.3302 35.7891L21.87 39.3209L14.6472 46.6536L18.2418 50.32L25.431 57.72L28.9248 61.2855L36.114 68.6855L32.553 72.3182L25.3302 79.6509L21.87 83.2164L14.6472 90.5155L18.2418 94.2155L25.431 101.615L28.9248 105.181L36.114 112.581L32.553 116.214L25.3302 123.546L21.87 127.078L14.6472 134.411L18.2418 138.077L25.431 145.477L28.9248 149.076L36.114 156.476L32.553 160.109L25.3302 167.442L21.87 170.974L14.6472 178.306L18.2418 181.973L25.431 189.373L28.9248 192.938L36.114 200.372L32.553 204.005L25.3302 211.337L21.87 214.869L14.6472 222.202L18.2418 225.868L25.431 233.268L28.9248 236.834L36.114 244.234L32.553 247.9L25.3302 255.233L21.87 258.765L21.6348 259"
          stroke="#CAA3CE"
          strokeMiterlimit="10"
        />
        <path
          d="M26.3044 0L32.6538 6.49182L36.114 10.0573L28.9248 17.39L25.3302 21.0564L18.141 28.3555L14.6472 31.9209L21.87 39.3209L25.431 42.9873L32.6538 50.3873L36.114 53.9527L28.9248 61.2855L25.3302 64.9182L18.141 72.2509L14.6472 75.7827L21.87 83.2164L25.431 86.8827L32.6538 94.2827L36.114 97.8482L28.9248 105.181L25.3302 108.814L18.141 116.146L14.6472 119.678L21.87 127.078L25.431 130.778L32.6538 138.178L36.114 141.744L28.9248 149.076L25.3302 152.709L18.141 160.042L14.6472 163.574L21.87 170.974L25.431 174.64L32.6538 182.04L36.114 185.605L28.9248 192.938L25.3302 196.605L18.141 203.937L14.6472 207.469L21.87 214.869L25.431 218.535L32.6538 225.935L36.114 229.501L28.9248 236.834L25.3302 240.5L18.141 247.799L14.6472 251.331L21.87 258.765L22.1052 259"
          stroke="#CAA3CE"
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <linearGradient id="paint0_linear_510_335" x1="0" y1="129.5" x2="472" y2="129.5" gradientUnits="userSpaceOnUse">
          <stop stopColor="#EFD6EF" />
          <stop offset="0.5419" stopColor="#FFE7E7" />
          <stop offset="1" stopColor="#EFD6EF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_510_335"
          x1="-0.167972"
          y1="129.5"
          x2="472.168"
          y2="129.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EFD6EF" />
          <stop offset="0.273243" stopColor="#FFD6D6" />
          <stop offset="0.711388" stopColor="#FFD6D6" />
          <stop offset="1" stopColor="#EFD6EF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default ChequeBackground;
